
import startMoodleSso from '~/graphql/queries/sso/startMoodleSso.gql';

export default {
  layout: 'login',
  middleware: 'guest',
  auth: false,
  async mounted() {
    try {
      const {data} = await this.$apollo.query({
        query: startMoodleSso,
      });

      window.location.replace(data.startMoodleSso);
    } catch (e) {
      console.error(e);
    }
  },
};
